import { gql } from 'graphql-tag';

export const CREATE_PROPOSAL_PREVIEW = gql`
  mutation CreateProposalPreview($input: CreateProposalV2Input!) {
    createProposalPreview(input: $input) {
      id
      success
      errorMessage
    }
  }
`;
